import { AuthStatus } from '../components';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <header className="landing-header">
        <h2>Valuera</h2>
        <p className="landing-subtitle">Dein Immobilienportfolio</p>
        <div
          style={{
            marginTop: '20px',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}
        >
          <AuthStatus />
        </div>
      </header>

      <main className="landing-main">
        <section className="cta-section">
          <h2>Get Started</h2>
          <p>
            The application is currently in development. Stay tuned for updates!
          </p>
          <button className="cta-button" disabled>
            Coming Soon
          </button>
        </section>
      </main>

      <footer className="landing-footer">
        <p>&copy; 2025 Valuera. Built with React and TypeScript.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
